import styled from 'styled-components';
import { ThemeColours } from '../styles/ThemeColours';

export const CTADot = styled.div`
  align-self: flex-start;
  background-color: ${ThemeColours.accent400};
  border-radius: 50%;
  height: 12px;
  margin-left: 4px;
  min-width: 12px;
`;

export const LinkContent = styled.span`
  align-items: center;
  display: flex;
`;
